import { Accordion, Alert, Button, Stack, styled } from '@/theme/index';

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  margin: '0',
  border: 'none',
  borderTop: `1px solid ${theme.palette.divider}`,

  '&:before': {
    display: 'none',
  },
  '&:hover': {
    boxShadow: 'none',
  },
  '.MuiAccordionDetails-root, .MuiAccordionSummary-root, .MuiAccordionSummary-content':
    {
      padding: 0,
      margin: 0,
    },
}));

export const StyledAlert = styled(Alert)(() => ({
  height: '42px',
  minWidth: '300px',
  padding: '0',
  borderRadius: '4px',

  '.MuiAlert-message': {
    width: '100%',
    padding: '0',
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  width: '40px',
  height: '40px',
  margin: theme.spacing(2.5, 3, 0, 0),
  minWidth: 'initial',
  borderRadius: '50%',
  marginLeft: theme.spacing(2.5),
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1.25, 2.5),
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: '4px',
  maxHeight: '400px',
  overflowY: 'scroll',
}));
